const GlobalStore = {}

let store;
// let state;
// let getters;

const CONFIRM_TYPE = {
    DEFAULT : 0,
    VERSION2 : 1,
    VERSION3 : 2,
    VERSION4 : 3,
    VERSION5 : 4,
    VERSION6 : 5,
}

GlobalStore.init = function(pStore){
    store = pStore;
        // state = store.state;
        // getters = store.getters;

    GlobalStore.modalTransitionName = () => store.state.modalTransitionName;
    GlobalStore.isFromJoinChat = () => store.state.isFromJoinChat
    GlobalStore.isShowBookmarkPopupNotExpert = () => store.state.isShowBookmarkPopupNotExpert
    GlobalStore.isShowMakeScheduleBallon = () => store.state.scheduleBallon
    GlobalStore.isMovePayAnimation = () => store.state.movePayAnimation
    GlobalStore.isShowToast = () => store.state.isShowToast;
    GlobalStore.isShowToastVer2 = () => store.state.isShowToastVer2
    GlobalStore.isShowProgress = () => store.state.progress
    GlobalStore.isShowCompleteProCondition = () => store.state.isShowCompleteProCondition
    GlobalStore.isShowPayAnimation = () => store.state.payAnimation
    GlobalStore.isShowProModal = () => store.state.proModal
    GlobalStore.isCompleteUpdate = () => store.state.completeUpdate
    GlobalStore.isShowSystemPatch = () => store.state.systemPatch
    GlobalStore.isShowUpdatePopup = () => store.state.updatePopup
    GlobalStore.toastVer2Type = () => store.state.toastVer2Type
    GlobalStore.toastStr = () => store.state.toastStr;
    GlobalStore.toastStrVer2 = () => store.state.toastStrVer2
    GlobalStore.loginInfo = () => store.state.loginInfo;
    GlobalStore.noticeCount = () => store.state.noticeCount
    GlobalStore.isShowConfirm = () => store.state.isShowConfirm;
    GlobalStore.confirmMsg = () => store.state.confirmMsg;
    GlobalStore.confirmOkName = () => store.state.confirmOkName;
    GlobalStore.confirmCancelName = () => store.state.confirmCancelName;
    GlobalStore.confirmType = () => store.state.confirmType;
    GlobalStore.changeWidth = () => store.state.changeWidth;
    GlobalStore.isJoin = () => store.state.isJoin;
    GlobalStore.isLogin = () => store.getters.isLogin;
    GlobalStore.isAdmin = () => store.getters.isAdmin;
    GlobalStore.isSoccerhowWrite = () => store.state.isSoccerhowWrite;
    GlobalStore.isOpenChatWrite = () => store.state.isOpenChatWrite;
    GlobalStore.requireMemberInfoSetting = () => store.state.requireMemberInfoSetting;
    GlobalStore.statusBarHeight = () => store.state.statusBarHeight;
    GlobalStore.navigationBarHeight = () => store.state.navigationBarHeight;
    GlobalStore.isGetPedoMeter = () => store.state.isGetPedoMeter;
    GlobalStore.walkCount = () => store.state.walkCount;
    GlobalStore.averageWalk = () => store.state.averageWalk;
    GlobalStore.yesterdayDiff = () => store.state.yesterdayDiff;
    GlobalStore.shareRegionCode = () => store.state.shareRegionCode;
    GlobalStore.chatCount = () => store.state.chatCount;
    GlobalStore.isShowPedometer = () => store.state.isShowPedometer;
    GlobalStore.deviceName = () => store.state.deviceName;
    GlobalStore.isShowPrivacyPolicy = () => store.state.isShowPrivacyPolicy;
    GlobalStore.isShowAppLinkToast = () => store.state.isShowAppLinkToast;
    GlobalStore.schemes = () => store.state.schemes;
    GlobalStore.isShowPositionPopup = () => store.state.isShowPositionPopup;
    GlobalStore.isShowDirectRequestPopup = () => store.state.isShowDirectRequestPopup;
    GlobalStore.requestInfo = () => store.state.requestInfo
    GlobalStore.isShowRequestPopupForce = () => store.state.isShowRequestPopupForce
    GlobalStore.isShowTransCoachPopup = () => store.state.isShowTransCoachPopup
    GlobalStore.isShowAfterPositionPopup = () => store.state.isShowAfterPositionPopup
    GlobalStore.isApply = () => store.state.isApply
    GlobalStore.isShowMemberInfoPopup = () => store.state.isShowMemberInfoPopup
    GlobalStore.getVisitReasonType = () => store.state.visitReasonType
    GlobalStore.isShowModifyPopup = () => store.state.isShowModifyPopup
    GlobalStore.modifyPopupInfo = () => store.state.modifyPopupInfo;
    GlobalStore.CONFIRM_TYPE = CONFIRM_TYPE;
}
// const hasOwnProperty = Object.prototype.hasOwnProperty;

    // _obj.setLoginInfo = function(userName, levelName){
    //     store.commit('setLoginInfo', {userName : userName, levelName : levelName});
    // }

GlobalStore.setVisitReasonType = function(visitReason) {
    store.commit('setVisitReasonType', {visitReason: visitReason})
}

GlobalStore.setIsShowModifyPopup = function (isShowModifyPopup, mode, reject_reason, member_career_history_idx) {
    store.commit('setIsShowModifyPopup', {isShowModifyPopup : isShowModifyPopup, mode : mode, reject_reason : reject_reason, member_career_history_idx : member_career_history_idx})
}

GlobalStore.setIsShowMemberInfoPopup = function (isShowMemberInfoPopup) {
    store.commit('setIsShowMemberInfoPopup', {isShowMemberInfoPopup : isShowMemberInfoPopup})
}


GlobalStore.setIsShowAfterPositionPopup = function(isShowAfterPositionPopup, isApply) {
    store.commit('setIsShowAfterPositionPopup', { isShowAfterPositionPopup: isShowAfterPositionPopup, isApply: isApply })
}

GlobalStore.setTransCoachPopup = function(isShowTransCoachPopup) {
    store.commit('setTransCoachPopup', { isShowTransCoachPopup: isShowTransCoachPopup })
}

GlobalStore.setIsShowDirectRequestPopup = function (isShowDirectRequestPopup, requestInfo) {
    store.commit('setIsShowDirectRequestPopup', {isShowDirectRequestPopup : isShowDirectRequestPopup, requestInfo : requestInfo})
}

GlobalStore.setIsShowRequestPopupForce = function (isShowRequestPopupForce) {
    store.commit('setIsShowRequestPopupForce', {isShowRequestPopupForce : isShowRequestPopupForce})
}

GlobalStore.closePositionPopup = function() {
    store.commit('closePositionPopup')
}

GlobalStore.setIsShowPositionPopup = function(isShowPositionPopup) {
    store.commit('setIsShowPositionPopup', isShowPositionPopup)
}

GlobalStore.setIsShowAppLinkToast = function(isShowAppLinkToast) {
    store.commit('setIsShowAppLinkToast', isShowAppLinkToast)
}

GlobalStore.setWalkCount = function(walkCount) {
    store.commit('setWalkCount', walkCount);
}

GlobalStore.setAverageWalk = function(averageWalk) {
    store.commit('setAverageWalk', averageWalk);
}

GlobalStore.closeIsShowBookmarkPopupNotExpert = function() {
    store.commit('closeIsShowBookmarkPopupNotExpert')
}

GlobalStore.closePrivacyPolicy = function() {
    store.commit('closePrivacyPolicy')
}

GlobalStore.setIsShowPrivacyPolicy = function() {
    store.commit('setIsShowPrivacyPolicy')
}

GlobalStore.setIsShowBookmarkPopupNotExpert = function() {
    store.commit('setIsShowBookmarkPopupNotExpert')
}

GlobalStore.setDevice = function(deviceName) {
    store.commit('setDevice', deviceName)
}

GlobalStore.setYesterdayDiff = function(yesterdayDiff) {
    store.commit('setYesterdayDiff', yesterdayDiff);
}

GlobalStore.setIsGetPedoMeter = function(isGetPedoMeter){
    store.commit('setIsGetPedoMeter', isGetPedoMeter)
}

GlobalStore.setLoginInfo = function(loginInfo){
    store.commit('setLoginInfo', loginInfo);
}

GlobalStore.setIsFromJoinChat = function(isFromJoinChat) {
    store.commit('setIsFromJoinChat', isFromJoinChat )
}

GlobalStore.setSoccerhowWrite = function(isWrite) {
    store.commit('checkSoccerhowWrite', isWrite)
}

GlobalStore.setIsOpenChatWrite = function(isWrite) {
    store.commit('setIsOpenChatWrite', isWrite)
}

GlobalStore.setNoticeCount = function(noticeCount) {
    store.commit('setNoticeCount', noticeCount)
}

GlobalStore.setChatCount = function(chatCount) {
    store.commit('setChatCount', chatCount)
}

GlobalStore.setLastModalFixedInIOS = function(top, height){
    store.commit('setLastModalFixedInIOS', {top : top, height : height});
}

GlobalStore.unsetLastModalFixedInIOS = function(modal_index = -1){
    store.commit('unsetLastModalFixedInIOS', modal_index);
}

GlobalStore.addModal = function(name, data){
    store.commit('addModal', Object.assign({view : name, ...data}));
}

GlobalStore.hideScheduleBallon = function() {
    store.commit('hideScheduleBallon')
}

GlobalStore.showUpdatePopup = function() {
    store.commit('showUpdatePopup')
}

GlobalStore.hideUpdatePopup = function() {
    store.commit('hideUpdatePopup')
}

GlobalStore.showSystemPatch = function() {
    store.commit('showSystemPatch')
}

GlobalStore.hideSystemPatch = function() {
    store.commit('hideSystemPatch')
}

GlobalStore.showProModal = function() {
    store.commit('showProModal')
}

GlobalStore.hideProModal = function() {
    store.commit('hideProModal')
}

GlobalStore.setIsShowCompleteProCondition = function(region_code) {
    store.commit('setIsShowCompleteProCondition', region_code)
}

GlobalStore.hideCompleteProCondition = function() {
    store.commit('hideCompleteProCondition')
}

GlobalStore.showProgress = function() {
    store.commit('showProgress')
}

GlobalStore.hideProgress = function() {
    store.commit('hideProgress')
}

GlobalStore.showPayAnimation = function() {
    store.commit('showPayAnimation')
}

GlobalStore.hidePayAnimation = function() {
    store.commit('hidePayAnimation')
}

GlobalStore.showToast = function(str){
    store.commit('showToast', str);
}

GlobalStore.closeLastModalLoop = function(data) {
    store.commit('closeLastModalLoop', {data})
}

GlobalStore.closeSpliceModal = function(data) {
    store.commit('closeSpliceModal', {data})
}

GlobalStore.showToastVer2 = function(str, type) {
    store.commit('showToastVer2', {str, type})
}

GlobalStore.showAlert = function(str){
    store.commit('showAlert', str);
}

GlobalStore.closeModalAll = function(){
    store.commit('closeModalAll');
}

GlobalStore.showConfirm = function(msg, okCallback, okName = '확인', cancelName = '취소', type = CONFIRM_TYPE.DEFAULT, isJoin = false, cancelCallback = null, changeWidth = 300){
    store.commit('showConfirm', {msg, okCallback, okName, cancelName, type, isJoin, cancelCallback, changeWidth});
}

GlobalStore.showMercenaryScheduleCancelConfirm = function(okCallback, cancelCallback = null){
    const html = `<strong style="color: #101014; display: inline-block;">시작까지 24시간 미만 남은 스케줄입니다</strong><br><br>시작 시간까지 24시간 미만 남은 스케줄을 취소할 경우,
                    <strong>No show (예약부도)</strong>처리가 되며 프로필에 이력이 남게 됩니다.<br>또한 용병 스카웃 시 결제한 스카웃 비용에 대해서는 <strong>환불 불가능</strong>, 현재 참여 중인 용병에게 비용이 전달됩니다.
                    <br>그래도 정말 스케줄을 취소하시겠습니까?<br><br>`;
    GlobalStore.showConfirm(html, okCallback, '스케줄 취소하기', '돌아가기', CONFIRM_TYPE.VERSION3, false, cancelCallback);
}

GlobalStore.showMercenaryJoinCancelConfirm = function(okCallback, cancelCallback = null){
    const html = `<strong style="color: #101014; display: inline-block;">시작까지 24시간 미만 남은 스케줄입니다</strong><br><br>시작 시간까지 24시간 미만 남은 스케줄에 용병 참여 취소할 경우,
                    <strong>No show (예약부도)</strong>처리가 되며 프로필에 이력이 남게 됩니다.<br>또한 코치 스케줄의 경우, 결제한 참여비가 있다면 <strong>환불 불가능</strong>하며, 현재 참여 중인 스케줄 매니저에게 비용이 전달됩니다.
                    <br>그래도 정말 용병 참여를 취소하시겠습니까?<br><br>`;
    GlobalStore.showConfirm(html, okCallback, '용병 참여 취소하기', '돌아가기', CONFIRM_TYPE.VERSION3, false, cancelCallback);
}

GlobalStore.showLoginConfirm = function(){
    GlobalStore.addModal('LoginIntro', {transitionName: 'right'});
    // GlobalStore.addModal('MemberTypeSelect', {
    //     isExistLoginBtn: true, isShowCloseBtn: false, completeAction: (register_type) => {
    //         this.$GlobalStore.addModal('RegistTypeSelect', { isModalBackTransparent: true, transitionName: 'bottom', register_type: register_type });
    //         // this.$GlobalStore.addModal('MemberRegist', { isModalBackTransparent: true, transitionName: 'bottom', register_type: register_type });
    //     }
    // })
    // GlobalStore.showConfirm( '로그인이 필요합니다.<br> 로그인 하시겠습니까?', () => {
    //    GlobalStore.addModal('Login', {transitionName : 'bottom', isModalBackTransparent: true});
    // }, '확인', '취소', CONFIRM_TYPE.DEFAULT);
}

GlobalStore.okConfirm = function(){
    store.state.confirmOkCallback();
}

GlobalStore.hideConfirm = function(isOkFunction = false){
    if(store.state.confirmCancelCallback && !isOkFunction) store.state.confirmCancelCallback();
    store.commit('hideConfirm');
}

const closeLastModal = function(isForceClose = false){
    store.commit('closeLastModal', isForceClose);
}

GlobalStore.logout = function(){
    store.commit('logout');
}

GlobalStore.getModalLength = function(){
    return store.state.modals.length;
}

GlobalStore.checkViewExist = function(viewName){
    const state = store.state;
    for(const i in state.modals){
        if(state.modals[i].view === viewName) {
            return state.modals[i];
        }
    }
    return null;
};

GlobalStore.addPopFlag = function(closeFunction){
    store.commit('addPopFlag', closeFunction);
};

GlobalStore.closeLastPop = function(isExecuteCloseAction){
    store.commit('closeLastPop', isExecuteCloseAction);
}

GlobalStore.checkIsMe = function(member_idx, member_type){
    if(GlobalStore.isLogin()){
        if(GlobalStore.loginInfo().idx == member_idx && GlobalStore.loginInfo().member_type == member_type){
            return true;
        }
    }

    return false;
}

GlobalStore.showRequiredMemberInfoSetting = function(type){
    store.commit('showRequiredMemberInfoSetting', type);
}

GlobalStore.hideRequiredMemberInfoSetting = function(){
    store.commit('hideRequiredMemberInfoSetting');
}

GlobalStore.setStatusBarHeight = function(height){
    store.commit('setStatusBarHeight', height);
}


GlobalStore.setNavigationBarHeight = function(height){
    store.commit('setNavigationBarHeight', height);
}

GlobalStore.setSchemes = function(action, param0, param1, param2){
    store.commit('setSchemes', {action : action, param0 : param0, param1 : param1, param2 : param2});
}

GlobalStore.closeLastModal = closeLastModal;

window.closeLastModal = closeLastModal;
// window.goLoginPage = closeLastModal;



export default GlobalStore;
